import { render, staticRenderFns } from "./SuppliersNotVerified.vue?vue&type=template&id=22d5c44f&scoped=true&"
import script from "./SuppliersNotVerified.vue?vue&type=script&lang=js&"
export * from "./SuppliersNotVerified.vue?vue&type=script&lang=js&"
import style0 from "./SuppliersNotVerified.vue?vue&type=style&index=0&id=22d5c44f&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22d5c44f",
  null
  
)

export default component.exports